//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { urlToKey, getWorkbook, getSheet } from "sheetsy";

import Params from "../../helpers/ParamsHelper";
import ConfigGroup from "../partials/ConfigGroup.vue";
import ApartmentForm from "../partials/ApartmentForm.vue";
import Selector from "./Selector.vue";
import ApartmentCard from "../partials/ApartmentCard.vue";

export default {
  name: "ApartmentConfig",
  components: {
    "config-group": ConfigGroup,
    "apartment-form": ApartmentForm,
    "apartment-selector": Selector,
    "apartment-card": ApartmentCard
  },
  data: function() {
    return {
      isFormVisible: false,
      options: null,
      step: 1,
      limit: 6,
      initialLimit: 6,
      isLight: false,
      list: null,
      categories: null,
      apartments: [],
      filteredApartments: [],
      selectedApartment: null,
      choices: [],
      isLoaded: false
    };
  },
  beforeMount() {
    let link =
      "https://docs.google.com/spreadsheets/d/1g0JJpL3wqXo9kEL48LJi9Sl0W0W55zLwBpGMc9LGT9A/edit?usp=sharing";
    let key = urlToKey(link);

    console.log("fetching data..");

    getSheet(key, "od6").then(sheet => {
      this.apartments = sheet.rows;
      this.filteredApartments = sheet.rows.filter(apartment => {
        return apartment.status.toLowerCase() !== "sprzedane";
      });
      if (Params.hasParam("apartment")) {
        let selected = sheet.rows.filter(item => {
          return item.id == Params.getParam("apartment");
        })[0];
        this.selectedApartment = selected;
        this.isLight = selected.color == "Jasny";
        this.step = 2;
      } else {
        this.step = 1;
      }

      this.isLoaded = true;
    });

    getSheet(key, "o38vgfb").then(sheet => {
      this.list = sheet.rows;
      let rows = sheet.rows;
      let categories = [];
      let options = [];

      this.list.forEach((item, index) => {
        if (!categories.includes(item.category)) {
          categories.push(item.category);
        }
      });

      categories.forEach((item, index) => {
        let category = {
          id: index,
          name: item,
          items: rows.filter(row => {
            return row.category == item;
          })
        };
        options.push(category);
      });

      this.options = options;
    });
  },

  methods: {
    handleFormOpen() {
      this.isFormVisible = true;
    },
    handleFormClose() {
      this.isFormVisible = false;
    },
    increaseLimit() {
      this.limit = this.limit + this.initialLimit;
    },
    handleApartmentSelection(load) {
      let selected = this.apartments.filter(item => item.id == load)[0];
      this.selectedApartment = selected;
      this.isLight = selected.color == "Jasny";
      if (Params.hasParam("apartment")) {
        Params.editParam("apartment", selected.id);
      } else {
        Params.addParam("apartment", selected.id);
      }
      this.step = 2;
    },
    handleChoiceUpdate(payload) {
      this.options.forEach((item, index) => {
        if (item.name == payload.category) {
          item.items.forEach((item, yndex) => {
            if (item.id == payload.id) {
              this.options[index].items[yndex].counter = payload.counter;
              this.options[index].items[yndex].isActive = payload.active;
            }
          });
        }
      });

      let choiceFinder = this.checkIfChoiceIsAdded(payload);
      if (choiceFinder.isFound) {
        this.choices[choiceFinder.index] = payload;
      } else {
        this.choices.push(payload);
      }
    },
    checkIfChoiceIsAdded(el) {
      var found = false;
      let index = 0;
      for (let i = 0; i < this.choices.length; i++) {
        if (this.choices[i].id == el.id) {
          found = true;
          index = i;
          break;
        }
      }

      return {
        isFound: found,
        index: index
      };
    }
  },
  computed: {
    personalizationCost() {
      let totalCost = 0;
      this.choices.forEach((item, index) => {
        if (item.details.nan == "FALSE") {
          totalCost += item.details.price * item.counter;
        }
      });
      return totalCost;
    },
    totalPrice() {
      if (this.selectedApartment) {
        let initialPrice = this.selectedApartment.price.replace(/[^\d.,]/g, "");
        return parseFloat(initialPrice) + this.personalizationCost;
      } else {
        return 0;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/components/ApartmentConfig.vue